export const IMAGE_UPLOADER_PROMPT_STATES = {
  BROWSE: 'Upload a Picture',
  SUCCESS: 'Successfully Uploaded',
  ERROR: 'Unsuccessful',
};

export const RECOMMOMENDED_THUMBNAIL_SIZE_TEXT = 'recommended 564 X 295px';
